import script from "./MsgContacts.vue?vue&type=script&setup=true&lang=js"
export * from "./MsgContacts.vue?vue&type=script&setup=true&lang=js"

import "./MsgContacts.vue?vue&type=style&index=0&id=63d919f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d919f6"]])

export default __exports__